export default "__VITE_ASSET__QIosE7mL__"